import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import SelectPicker from '../../../components/SelectPicker';
import FormInput from '../../../components/FormInput';
import {ModelListSelect} from 'vue-search-select';

export default {
    components: {Datepicker, SelectPicker, FormInput, ModelListSelect},
    data() {
        return {
            date_from: null,
            date_to: null,
            daily: false,
            monthly: false,

            dispatchers: [],
            selectedDispatchers: [],
            result: [],
            routes: [],
            total: {},
            loadingState: false,
            fromError: false,
            toError: false,
            inputClass: ['form-control base_input'],
            //alx no git haha
            transporters: [],
            selectedTransporter: null,
        }
    },
    created() {
        this.getTransporters(); //alx
    },
    methods: {
        reportDaily() {
            this.daily = true;
            this.monthly = false;

            this.date_from = new Date();
            this.date_to = new Date();
            this.makeRequest({daily: true});
        },
        reportMonthly() {
            this.monthly = true;
            this.daily = false;

            var date = new Date();
            this.date_from = new Date(date.getFullYear(), date.getMonth(), 1);
            this.date_to = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            this.makeRequest({monthly: true});
        },
        reportCustom() {
            this.daily = false;
            this.monthly = false;

            if (this.date_from && this.date_to) {
                this.inputClass.splice(1, 1);
                let fromDate = this.$moment(this.date_from).startOf('day').format('Y-MM-DD');
                let toDate = this.$moment(this.date_to).endOf('day').format('Y-MM-DD');
                this.makeRequest({from: fromDate, to: toDate});
            } else {
                if (!this.date_from) {
                    this.fromError = true;
                }
                if (!this.date_to) {
                    this.toError = true;
                }
                this.inputClass.push('is-invalid');
            }
        },
        // makeRequest(params) {
        //     this.loadingState = true;
        //     this.$api.post('reports.dispatcher', params).then(res => {
        //         this.result = res.data.trips;
        //         this.routes = res.data.routes;
        //         this.calculateTotal();
        //     }).finally(() => {
        //         this.loadingState = false;
        //     })
        // },
        makeRequest(params) {
            this.loadingState = true;
            params.transporter_id = this.selectedTransporter; //alx
            this.$api.post('reports.dispatcher-view', params).then(res => {
                this.result = res.data;
                this.calculateTotal();
            }).finally(() => {
                this.loadingState = false;
            })
        },
        routeName(route_id) {
            let route = this.routes.find(r => r.id === route_id);
            if (route) {
                return route.name;
            } else {
                return 'Route: ' + route_id;
            }
        },
        calculateTotal() {
            this.total.passengers = this.result.reduce((sum, a) => sum + a.passengers,0);
            this.total.baggage = this.result.reduce((sum, a) => sum + a.baggage,0);
            this.total.amount = this.result.reduce((sum, a) => sum + a.amount,0);
            this.total.terminal_amount = this.result.reduce((sum, a) => sum + a.terminal_amount,0);
            this.total.online_amount = this.result.reduce((sum, a) => sum + a.online_amount,0); //alx
        },
        printData() {
            let fontSize = this.$refs.printTable.style.fontSize;
            this.$refs.printTable.style.fontSize = '13.5px';
            this.displayNoneLoop = false;
            let mywindow = window.open('', 'PRINT');
            mywindow.document.write('<html><head><title>' + document.title + '</title>');
            mywindow.document.write('<link rel="stylesheet" href="/css/lib.css" />');
            mywindow.document.write('<link rel="stylesheet" href="/css/app.css" />');
            mywindow.document.write('<link rel="stylesheet" href="/print.css" />');
            mywindow.document.write('</head><body >');
            mywindow.document.write(document.getElementById('table').innerHTML);
            mywindow.document.write('</body></html>');

            mywindow.document.close();
            mywindow.focus();
            this.$refs.printTable.style.fontSize = fontSize;

            setTimeout(() => {
                mywindow.print();
                mywindow.close();
            }, 1000)
        },
        exportToExcel() {
            let fileName = 'Отчет_диспетчеризации_' + this.$moment(this.fromDate).format('DDMMYYYY') + '-' + this.$moment(this.toDate).format('DDMMYYYY') + '.xls';
            this.$api.download('xls.dispatcherReport', {
                fromDate: this.$moment(this.date_from),
                toDate: this.$moment(this.date_to),
                monthly: this.monthly ? 1 : 0,
                daily: this.daily ? 1 : 0,
                transporter_id: this.selectedTransporter, //alx
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName); //or any other extension
                document.body.appendChild(link);
                link.click();
            });
        },
        //alx
        getTransporters() {
            this.$api.get('transporter-reports.get-transporters').then(({data}) => {
                this.transporters = data;
            })
        }
    },
    filters: {
        moneyFormat(num) {
            return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
        },
    }
}
